'use client';

import styles from './footer.module.css';
import logo from "../assets/footerlogo.jpg" // ✅ adjust path if needed

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.footerContent}>
        <div className={styles.footerGrid}>
          {/* Column 1: Logo and Description */}
          <div className={styles.logoColumn}>
            <div className={styles.logoContainer}>
              <img src={logo} alt="WayForSky" className={styles.logoImage} />
            </div>
            <p className={styles.description}>
              Leading aviation training academy, transforming aspiring individuals into professional pilots and aviation experts.
            </p>
          </div>

          {/* Quick Links */}
          <div className={styles.quickLinksColumn}>
            <h3 className={styles.newsletterTitle} style={{ color: '#000', fontSize: '18px', fontWeight: '500', marginBottom: '16px' }}>Quick Links</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li><a href="/" style={{ color: '#4b5563', textDecoration: 'none', fontSize: '15px' }}>Home</a></li>
              <li><a href="/our-story" style={{ color: '#4b5563', textDecoration: 'none', fontSize: '15px' }}>About Us</a></li>
              <li><a href="/courses" style={{ color: '#4b5563', textDecoration: 'none', fontSize: '15px' }}>Courses</a></li>
              <li><a href="/fleet" style={{ color: '#4b5563', textDecoration: 'none', fontSize: '15px' }}>Fleet</a></li>
              <li><a href="/contactus" style={{ color: '#4b5563', textDecoration: 'none', fontSize: '15px' }}>Contact</a></li>
            </ul>
          </div>

          {/* Column 2: Contact Information */}
          <div className={styles.contactColumn}>
            <div className={styles.contactBlock}>
              <span className={styles.contactLabel}>Email</span>
              <span className={styles.contactValue}>info@wayforsky.com</span>
            </div>
            <div className={styles.contactBlock}>
              <span className={styles.contactLabel}>Phone number</span>
              <span className={styles.contactValue}>+91 9071165504</span>
            </div>
            <div className={styles.contactBlock}>
              <span className={styles.contactLabel}>Location</span>
              <span className={styles.contactValue}>Bangalore, Karnataka</span>
            </div>
          </div>

          {/* Column 3: Newsletter Subscription */}
          <div className={styles.newsletterColumn}>
            <p className={styles.newsletterTitle}>Subscribe to program alerts</p>
            <form className={styles.newsletterForm} onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Enter your email"
                className={styles.emailInput}
              />
              <button type="submit" className={styles.submitButton}>
                Submit
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 3L14 10L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </form>
          </div>

          {/* Column 4: Social Media */}
          <div className={styles.socialColumn}>
            <div className={styles.socialIcons}>
              <a href="https://www.facebook.com/share/1AGxzRJJHz/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Facebook">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 10H17L16 14H13V22H9V14H6V10H9V8C9 5.791 10.791 4 13 4H16V8H14C13.448 8 13 8.448 13 9V10Z" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://youtube.com/@wayforsky?si=53LfJr3Pp7hZjlt0" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="YouTube">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.582 6.186a2.506 2.506 0 0 0-1.762-1.766C18.265 4 12 4 12 4s-6.264 0-7.82.42a2.505 2.505 0 0 0-1.762 1.766C2 7.74 2 12 2 12s0 4.26.418 5.814a2.506 2.506 0 0 0 1.762 1.766C5.735 20 12 20 12 20s6.265 0 7.82-.42a2.505 2.505 0 0 0 1.762-1.766C22 16.26 22 12 22 12s0-4.26-.418-5.814zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/wayforskyofficial?igsh=bGJhY25jN3VvNWtr" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Instagram">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="4" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2"/>
                  <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Row: Copyright and Back to Top */}
        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            © {new Date().getFullYear()} Copyright, All Rights Reserved by <span className={styles.brandName}>WayForSky</span>
          </div>
          <button onClick={scrollToTop} className={styles.backToTop}>
            Back to top
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 17V3M10 3L3 10M10 3L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </footer>
  );
}